// Copyright 2022, Imprivata, Inc.  All rights reserved.

import type { ApiErrorPayloadCommon } from '@imprivata-cloud/common';
import type { CodingContext } from '@imprivata-cloud/data-privacy-js';
import { useMutation } from '@tanstack/react-query';
import { usePlatform } from '../../context/platform/hooks';
import { apiClient } from '../client';

interface CreateInquiryResponse {
  inquiryUrl: string;
}

const createInquiryRequest = async (codingContext: CodingContext | undefined): Promise<string> => {
  const response = await apiClient.post<CreateInquiryResponse>('inquiry', (_) => {}, codingContext);
  return response.inquiryUrl;
};

export const useCreateInquiryMutation = () => {
  const { codingContext } = usePlatform();
  const mutation = useMutation<string, ApiErrorPayloadCommon>({
    mutationFn: () => createInquiryRequest(codingContext),
    onSuccess: (inquiryUrl) => {
      globalThis.location.href = inquiryUrl;
    },
  });

  return {
    createInquiry: mutation.mutate,
    ...mutation,
  };
};
